export interface Salarie{
  clientFinal_id:number
  candidate_id:number
  first_name:string
  last_name:string
  email:string
  personal_email:string
  phone_number:number
  salary:number
  cv:string
  skills:number []
 
  }
  export const headerColumns9=[
    { checked: true, name: 'Nom', code: 'first_name' },
    { checked: true, name: 'Poste', code: 'poste' },
    { checked: true, name: 'Projet', code: 'project_names' },
    { checked: true, name: 'Expérience', code: 'years_of_experience' },
    { checked: true, name: 'N° Tel', code: 'phone_number' },
    { checked: true, name: 'Salaire', code: 'salary' },
    { checked: true, name: 'Email Personnel', code: 'email' },
    { checked: true, name: 'Email Professionnel', code: 'emailProClient'},
    { checked: true, name: 'Dernière connexion', code: 'last_connection' },
  ];
  export const headerColumns15=[
    { checked: true, name: 'Nom', code: 'first_name' },
    { checked: true, name: 'Poste', code: 'poste' },
    { checked: true, name: 'Projet', code: 'project_names' },
    { checked: true, name: 'Expérience', code: 'years_of_experience' },
    { checked: true, name: 'N° Tel', code: 'phone_number' },
    { checked: true, name: 'Salaire', code: 'salary' },
    { checked: true, name: 'Email Personnel', code: 'email' },
    { checked: true, name: ' Email Professionnel', code:'emailProESN' },
    { checked: true, name: 'Dernière connexion', code: 'last_connection' },
  ];